/** Choose app / product picker — default landing page. */
export const MODULE_HUB_PATH = '/';

/** Legacy choose-app URL — redirects to {@link MODULE_HUB_PATH}. */
export const LEGACY_CHOOSE_APP_PATH = '/choose-app';

/** Generic organization sign-in (not module-scoped). */
export const ORG_SIGN_IN_PATH = '/sign-in';

/** Legacy org sign-in URL — redirects to {@link ORG_SIGN_IN_PATH}. */
export const LEGACY_MODULE_HUB_PATH = '/login';

/** Org self-service registration. */
export const REGISTER_PATH = '/register';

/** @deprecated Use {@link MODULE_HUB_PATH} */
export const CHOOSE_APP_PATH = MODULE_HUB_PATH;

/** Legacy org signup URL — redirect to {@link REGISTER_PATH}. */
export const LEGACY_REGISTER_PATH = '/register';

/** Platform operator sign-in (not linked from public hub). */
export const MASTER_SIGN_IN_PATH = '/master/login';
